import { ConversationOrderSummary } from '../../../../components/ConversationOrderSummary'
import { useCartContext } from '../../../../providers/CartProvider'
import { type ConversationCartComponent } from '../../../../value-objects/ConversationTurnItem'

export interface IConversationCartProps {
  cart: ConversationCartComponent
}

export const ConversationCart = ({ cart }: IConversationCartProps) => {
  const {
    decorate,
    isContinuing,
    increment,
    decrement,
    remove,
    continueToOrderRequest,
  } = useCartContext()

  const { items, total, currency, disabled } = decorate(cart)

  return (
    <ConversationOrderSummary
      items={items}
      total={total}
      currency={currency}
      disabled={disabled}
      isContinueLoading={isContinuing}
      onIncrement={increment}
      onDecrement={decrement}
      onRemove={remove}
      onContinue={continueToOrderRequest}
    />
  )
}
